export default __webpack_public_path__ + "static/media/Warlord's Dagger.5be4e64b.jpg";